module.exports = __webpack_public_path__ + "static/media/bg2.0942cc0d.webp";